import React, { useEffect, useState } from 'react';
import styles from '../App.module.css';
import { useLocation } from 'react-router-dom';

function About() {
  const [team, setTeam] = useState([]);
  const [about, setAbout] = useState({});
  const location = useLocation();
  const slug = location.pathname.split("/").filter(Boolean).pop();
  const baseurl = process.env.REACT_APP_API_BASE_URL;
  const getAbout = async() => {
    try {
      const response = await fetch(`${baseurl}get-pages.php/${slug}`);
      const result = await response.json();
      setAbout(result.data.length > 0 && result.data[0]); // Adjust based on your API response       
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {}
  };
  const fetchEvents = async() => {
    try {
      const response = await fetch(`${baseurl}get-team.php`);
      const result = await response.json();
      setTeam(result.data); // Adjust based on your API response        
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {}
  };
  useEffect(()=>{
    console.log(baseurl)
    getAbout()
    fetchEvents()
  },[])
  return (
    <>
      <section id="home" className={`${styles.hero} ${styles.about_banner}`} data-aos="fade-up" style={{backgroundImage: `url(${about.banner_image})`}}>
        <div className="container">
          <div className='row'>
            <div className="col-md-12">            
              <h1 className='font-bold leading-12 text-5xl'>About Us</h1>
              <p className="text-white text-xl font-semibold mt-2 mb-0 w-2/5">it is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
            </div>
          </div>
        </div>
      </section>
      {
        <div dangerouslySetInnerHTML={{__html: about.description}}/>
      }
      <section className={`py-10 ${styles.teams_section}`}>
        <div className="container">
          <div className="row align-items-end">
            <div className="col-md-4">
              <h1 className='font-bold text-black leading-12 text-4xl uppercase mb-0'>meet <br/> our team.</h1>
            </div>
            <div className="col-md-8">
              <p className="text-black mb-0 w-3/5 font-semibold">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. </p>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-md-12">
              <div className="grid grid-cols-3 gap-28"> 
                {
                  team.length > 0 && team.map((team)=>
                    <div className="rounded-lg" key={team.name}>
                      <img loading="lazy" className="img-fluid" src={team.image} alt={team.name} />
                      <h5 className="mb-0 mt-2 text-xl font-bold tracking-tight text-gray-900 dark:text-white capitalize">{team.name}</h5>
                      <p className="mb-3 font-semibold text-gray-800 dark:text-gray-400 capitalize">{team.position}</p>
                    </div>
                  )
                }                
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default About